<template>
  <el-dialog
    v-drag:common
    :title="this.type === 'edit' ? '编辑任务' : '新建任务'"
    :visible.sync="modal"
    width="60%"
  >
    <div class="add-task-wrapper">
      <el-form label-width="80px" :model="formData" ref="form" :rules="rules">
        <el-row>
          <el-col :span="10">
            <el-form-item label="项目名称" prop="workName">
              <el-input
                v-model="formData.workName"
                placeholder="请填写项目名称"
                :maxlength="100"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="this.type === 'edit'">
            <div :style="{ color: '#fff', lineHeight: '28px' }">
              当前状态： {{ stateList }}
            </div>
          </el-col>
        </el-row>
        <!-- <p class="title">各部分撰写人：</p>
        <el-row>
          <el-col :span="8">
            <el-form-item label="概述" prop="summaryUser">
              <el-select v-model="formData.summaryUser" placeholder="请选择">
                <el-option
                  :label="item.name"
                  :value="item.userId"
                  v-for="item in userList"
                  :key="item.userId"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="风资源" prop="windUser">
              <el-select v-model="formData.windUser" placeholder="请选择">
                <el-option
                  :label="item.name"
                  :value="item.userId"
                  v-for="item in userList"
                  :key="item.userId"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="风场规划" prop="farmUser">
              <el-select v-model="formData.farmUser" placeholder="请选择">
                <el-option
                  :label="item.name"
                  :value="item.userId"
                  v-for="item in userList"
                  :key="item.userId"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="载荷" prop="loadUser">
              <el-select v-model="formData.loadUser" placeholder="请选择">
                <el-option
                  :label="item.name"
                  :value="item.userId"
                  v-for="item in userList"
                  :key="item.userId"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="经评" prop="economicUser">
              <el-select v-model="formData.economicUser" placeholder="请选择">
                <el-option
                  :label="item.name"
                  :value="item.userId"
                  v-for="item in userList"
                  :key="item.userId"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="其他" prop="otherUser">
              <el-select v-model="formData.otherUser" placeholder="请选择">
                <el-option
                  :label="item.name"
                  :value="item.userId"
                  v-for="item in userList"
                  :key="item.userId"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>-->
        <p class="title">工作协同流程：</p>
        <el-row type="flex">
          <el-col :span="6.2">
            <el-form-item label="撰写">
              <!-- <el-select
                v-model="item.uploadUser"
                filterable
                placeholder="请选择"
                :disabled="type==='edit'"
              >
                <el-option
                  :label="item.name"
                  :value="item.userId"
                  v-for="item in userList"
                  :key="item.userId"
                ></el-option>
              </el-select> -->
              <el-input v-model="uploadUser" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex">
          <el-col
            v-for="(item, index) in formData.reviewUser"
            :key="item.key"
            :span="6.2"
          >
            <el-form-item :label="index === 0 ? '检阅' : ''" prop="reviewUser">
              <el-select
                v-model="item.reviewUser"
                filterable
                placeholder="请选择"
                :disabled="
                  (cowork.state > 1 || item.state === 1) && type === 'edit'
                "
              >
                <el-option
                  :label="item.name"
                  :value="item.userId"
                  v-for="item in userList"
                  :key="item.userId"
                ></el-option>
              </el-select>
              <i
                class="el-icon-minus del-icon"
                @click="delReviewUser(index)"
                v-if="
                  cowork.state < 2 &&
                    formData.reviewUser.length > 1 &&
                    item.state !== 1
                "
              ></i>
            </el-form-item>
          </el-col>
          <el-col :span="2" class="add-icon" v-if="cowork.state < 2">
            <i class="el-icon-plus" @click="addReviewUser"></i>
          </el-col>
        </el-row>
        <el-row type="flex">
          <el-col
            v-for="(item, index) in formData.checkUser"
            :key="item.key"
            :span="6.2"
          >
            <el-form-item :label="index === 0 ? '验查' : ''" prop="checkUser">
              <el-select
                v-model="item.checkUser"
                filterable
                placeholder="请选择"
                :disabled="
                  (cowork.state > 2 || item.state === 1) && type === 'edit'
                "
              >
                <el-option
                  :label="item.name"
                  :value="item.userId"
                  v-for="item in userList"
                  :key="item.userId"
                ></el-option>
              </el-select>
              <i
                class="el-icon-minus del-icon"
                @click="delCheckUser(index)"
                v-if="
                  cowork.state < 3 &&
                    formData.checkUser.length > 1 &&
                    item.state !== 1
                "
              ></i>
            </el-form-item>
          </el-col>
          <el-col :span="2" class="add-icon" v-if="cowork.state < 3">
            <i class="el-icon-plus" @click="addCheckUser"></i>
          </el-col>
        </el-row>
        <el-row type="flex">
          <el-col
            v-for="(item, index) in formData.signUser"
            :key="item.key"
            :span="6.2"
          >
            <el-form-item :label="index === 0 ? '会签' : ''" prop="signUser">
              <el-select
                v-model="item.signUser"
                filterable
                placeholder="请选择"
                :disabled="
                  (cowork.state > 3 || item.state === 1) && type === 'edit'
                "
              >
                <el-option
                  :label="item.name"
                  :value="item.userId"
                  v-for="item in userList"
                  :key="item.userId"
                ></el-option>
              </el-select>
              <i
                class="el-icon-minus del-icon"
                @click="delSignUser(index)"
                v-if="
                  cowork.state < 4 &&
                    formData.signUser.length > 1 &&
                    item.state !== 1
                "
              ></i>
            </el-form-item>
          </el-col>
          <el-col :span="2" class="add-icon" v-if="cowork.state < 4">
            <i class="el-icon-plus" @click="addSignUser"></i>
          </el-col>
        </el-row>
        <el-row type="flex">
          <el-col
            v-for="(item, index) in formData.approveUser"
            :key="item.key"
            :span="6.2"
          >
            <el-form-item :label="index === 0 ? '核定' : ''" prop="approveUser">
              <el-select
                v-model="item.approveUser"
                filterable
                placeholder="请选择"
                :disabled="
                  (cowork.state > 4 || item.state === 1) && type === 'edit'
                "
              >
                <el-option
                  :label="item.name"
                  :value="item.userId"
                  v-for="item in userList"
                  :key="item.userId"
                ></el-option>
              </el-select>
              <i
                class="el-icon-minus del-icon"
                @click="delApproveUser(index)"
                v-if="formData.approveUser.length > 1 && item.state !== 1"
              ></i>
            </el-form-item>
          </el-col>
          <el-col :span="2" class="add-icon" v-if="cowork.state < 5">
            <i class="el-icon-plus" @click="addApproveUser"></i>
          </el-col>
        </el-row>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">保存</el-button>
        </el-form-item>
      </el-form>
    </div>
  </el-dialog>
</template>
<script>
export default {
  props: ['visible', 'id', 'type'],
  data() {
    return {
      modal: false,
      userList: [],
      cowork: { state: -1 },
      uploadUser: '',
      formData: {
        workName: '',
        // summaryUser: '',
        // windUser: '',
        // farmUser: '',
        // loadUser: '',
        // economicUser: '',
        // otherUser: '',
        reviewUser: [
          {
            reviewUser: ''
          }
        ],
        checkUser: [
          {
            checkUser: ''
          }
        ],
        signUser: [
          {
            signUser: ''
          }
        ],
        approveUser: [
          {
            approveUser: ''
          }
        ]
      },
      rules: {
        workName: [
          { required: true, message: '请输入项目名称', trigger: 'blur' }
        ],
        summaryUser: [
          { required: true, message: '请选择概述撰写人', trigger: 'change' }
        ],
        windUser: [
          { required: true, message: '请选择风资源撰写人', trigger: 'change' }
        ],
        farmUser: [
          { required: true, message: '请选择风场规划撰写人', trigger: 'change' }
        ],
        loadUser: [
          { required: true, message: '请选择载荷撰写人', trigger: 'change' }
        ],
        economicUser: [
          { required: true, message: '请选择经评撰写人', trigger: 'change' }
        ],
        otherUser: [
          { required: true, message: '请选择其他撰写人', trigger: 'change' }
        ],
        reviewUser: [
          {
            required: true,
            validator: (rules, value, callback) => {
              const filterArr = value.map(item => {
                return item.reviewUser;
              });
              if (!filterArr.some(Boolean)) {
                return callback(new Error('请选择检阅'));
              }
              callback();
            }
          }
        ],
        checkUser: [
          {
            required: true,
            validator: (rules, value, callback) => {
              const filterArr = value.map(item => {
                return item.checkUser;
              });
              if (!filterArr.some(Boolean)) {
                return callback(new Error('请选择验查'));
              }
              callback();
            }
          }
        ],
        signUser: [
          {
            required: true,
            validator: (rules, value, callback) => {
              const filterArr = value.map(item => {
                return item.signUser;
              });
              if (!filterArr.some(Boolean)) {
                return callback(new Error('请选择会签'));
              }
              callback();
            }
          }
        ],
        approveUser: [
          {
            required: true,
            validator: (rules, value, callback) => {
              const filterArr = value.map(item => {
                return item.approveUser;
              });
              if (!filterArr.some(Boolean)) {
                return callback(new Error('请选择核定'));
              }
              callback();
            }
          }
        ]
      }
    };
  },
  watch: {
    modal(val) {
      this.$emit('update:visible', val);
    },
    async visible(val) {
      this.modal = val;
      this.formData = {
        workName: '',
        reviewUser: [
          {
            reviewUser: ''
          }
        ],
        checkUser: [
          {
            checkUser: ''
          }
        ],
        signUser: [
          {
            signUser: ''
          }
        ],
        approveUser: [
          {
            approveUser: ''
          }
        ]
      };
      this.$refs.form.clearValidate();
      if (this.type === 'edit' && val) {
        await this.getDetailInfo();
      }
    }
  },
  async mounted() {
    await this.getUserList();
    this.uploadUser = this.$store.state.user.name;
    //console.log(this.$store.state.user, 'this.$store.state.user...');
  },
  computed: {
    stateList() {
      if (this.cowork.state === 0) return '撰写中';
      if (this.cowork.state === 1) return '检阅中';
      if (this.cowork.state === 2) return '验查中';
      if (this.cowork.state === 3) return '会签中';
      if (this.cowork.state === 4) return '核定中';
      if (this.cowork.state === 5) return '完成';
      return '';
    }
    // isEditDisable(item) {
    //   return item.state === 1 && this.type === 'edit'
    // }
  },
  methods: {
    onSubmit() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          const filterReviewUser = this.fitlerArrayToStr(
            this.formData.reviewUser,
            'reviewUser'
          );
          const filterCheckUser = this.fitlerArrayToStr(
            this.formData.checkUser,
            'checkUser'
          );
          const filterSignUser = this.fitlerArrayToStr(
            this.formData.signUser,
            'signUser'
          );
          const filterApproveUser = this.fitlerArrayToStr(
            this.formData.approveUser,
            'approveUser'
          );

          let params = {
            ...this.formData,
            ...{
              uploadUser: this.$store.state.user.userId,
              reviewUser: filterReviewUser,
              checkUser: filterCheckUser,
              signUser: filterSignUser,
              approveUser: filterApproveUser
            }
          };
          if (this.type === 'edit') {
            params = {
              ...{
                reviewUser: filterReviewUser,
                checkUser: filterCheckUser,
                signUser: filterSignUser,
                approveUser: filterApproveUser,
                workName: this.formData.workName,
                uploadUser: this.$store.state.user.userId
              },
              ...{
                workId: this.id
              }
            };
            await this.$postForm({
              url: '/cowork/project/updateCowork',
              module: 'work',
              data: params,
              showError: true,
              showSuccess: true
            });
          } else {
            await this.$postForm({
              url: '/cowork/project/createCowork',
              module: 'work',
              data: params,
              showError: true,
              showSuccess: true
            });
          }
          this.$refs.form.resetFields();
          this.formData = {
            ...this.formData,
            ...{
              reviewUser: [
                {
                  value: ''
                }
              ],
              checkUser: [
                {
                  value: ''
                }
              ],
              signUser: [
                {
                  value: ''
                }
              ],
              approveUser: [
                {
                  value: ''
                }
              ]
            }
          };
          this.$emit('close');
          //console.log(this.formData, 'formData...');
        } else {
          return false;
        }
      });
    },
    fitlerArrayToStr(arr, id) {
      const str = arr
        .map(item => {
          return item[id];
        })
        .join();
      return str;
    },
    async getUserList() {
      const { data } = await this.$fetch.get('/cowork/project/getUserList', {
        module: 'work'
      });
      this.userList = data.userList;
    },
    async getDetailInfo() {
      const { data } = await this.$fetch.get('/cowork/project/getCoworkInfo', {
        module: 'work',
        params: { workId: this.id }
      });
      const {
        reviewUserList,
        signUserList,
        checkUserList,
        approveUserList,
        cowork
      } = data;
      this.formData.reviewUser = reviewUserList;
      this.formData.signUser = signUserList;
      this.formData.checkUser = checkUserList;
      this.formData.approveUser = approveUserList;
      this.cowork = cowork;
      this.formData.workName = cowork.workName;
      //console.log(this.reviewUser, 'this.reviewUser...');
    },
    addReviewUser() {
      this.formData.reviewUser.push({
        value: '',
        key: Date.now()
      });
      //console.log(this.formData, 'formData...');
    },
    addCheckUser() {
      this.formData.checkUser.push({
        value: '',
        key: Date.now()
      });
    },
    addSignUser() {
      this.formData.signUser.push({
        value: '',
        key: Date.now()
      });
    },
    addApproveUser() {
      this.formData.approveUser.push({
        value: '',
        key: Date.now()
      });
    },
    delReviewUser(index) {
      this.formData.reviewUser.splice(index, 1);
    },
    delCheckUser(index) {
      this.formData.checkUser.splice(index, 1);
    },
    delSignUser(index) {
      this.formData.signUser.splice(index, 1);
    },
    delApproveUser(index) {
      this.formData.approveUser.splice(index, 1);
    }
  }
};
</script>
<style lang="less" scoped>
/deep/.el-dialog__body {
  padding-left: 0px !important;
  padding-right: 0px;
}
.add-task-wrapper {
  padding: 20px 0px;
  overflow-x: auto;
  .title {
    color: #ffffff;
    padding: 5px;
    font-size: 12px;
    background-color: #0477a1b3;
  }

  /deep/.el-form-item__label {
    color: #e3e3e3;
  }

  /deep/.el-input__inner {
    width: 120px !important;
    background-color: transparent !important;
    color: #ffffff;
    border: none;
    border-bottom: 1px solid #ffffff;
    border-radius: 0;
  }

  .add-icon,
  .del-icon {
    color: #ffffff;
    padding: 5px;
    box-sizing: border-box;
  }
}
/deep/.container-layout .container-layout-content > .el-main {
  border: none !important;
}
</style>
